<template>
  <div>
    <section id="add-meta-template-messages" class="pb-8">
      <configuration v-if="page === 0" :data="metaTemplateMessages" @nextPage="nextPage" @checkName="checkTemplateName"></configuration>
      <message v-else-if="page === 1" :data="metaTemplateMessages" @previousPage="previousPage" @add="add"></message>
    </section>
  </div>
</template>

<script>
import { formatRouteTenantPath } from '@/utils'
import metaMessageTemplateApi from '@/http/requests/metaMessageTemplate'

import Configuration from './Components/Wizard/Configuration'
import Message from './Components/Wizard/Message'

export default {
  name: 'add-meta-template-messages',
  components: {
    Configuration,
    Message
  },
  data() {
    return {
      metaTemplateMessages: {
        name: '',
        category: '',
        bodyText: '',
        valid: true,
        headerText: null,
        footerText: null,
        variableExamples: [],
        buttons: [],
        buttonType: [
          { text: "Resposta rápida" , value: 'QUICK_REPLY', selected: false }
        ],
      },
      page: 0
    }
  },
  methods: {
    nextPage() {
      this.page++;
    },
    previousPage() {
      this.page--;
    },
    async checkTemplateName(){
      let counter = (await metaMessageTemplateApi.count({name: this.metaTemplateMessages.name})).data.data.metaMessageTemplateCount || 0;
      this.metaTemplateMessages.valid = counter === 0;
      this.$emit("setValid", this.metaTemplateMessages.valid);
    },
    async add() {
      const components = []

      if (this.metaTemplateMessages.headerText && this.metaTemplateMessages.headerText.length >= 1) {
        components.push({
          'type': 'HEADER',
          "format": "TEXT",
          'text': this.metaTemplateMessages.headerText
        })
      }

      const body = {
        'type': 'BODY',
        'text': `""${this.metaTemplateMessages.bodyText}""`
      }

      if (this.metaTemplateMessages.variableExamples.length > 0) {
        body.example = {
          body_text: [[]]
        }

        for (const example of this.metaTemplateMessages.variableExamples) {
          if (example.value !== '') {
            body.example.body_text[0].push(example.value)
          }
        }

        if (body.example.body_text[0].length === 0) {
          delete body.example
        }
      }

      components.push(body)

      if (this.metaTemplateMessages.footerText && this.metaTemplateMessages.footerText.length > 0) {
        components.push({
          'type': 'FOOTER',
          'text': this.metaTemplateMessages.footerText
        })
      }

      if (this.metaTemplateMessages.buttons && this.metaTemplateMessages.buttons.length > 0) {
        let subType = this.metaTemplateMessages.buttonType.filter(type => type.selected)[0].value;
        let buttons = [];

        this.metaTemplateMessages.buttons.forEach((item) => {
          buttons.push({
            'type': subType,
            'text': item.description
          })
        })

        components.push({
          'type': 'BUTTONS',
          'buttons': buttons
        });
      }

      try {
        await metaMessageTemplateApi.add({
          name: this.metaTemplateMessages.name,
          category: this.metaTemplateMessages.category,
          components
        })
      } catch (error) {
        if (JSON.parse(error.request.response).errors[0].code === 401) {
          this.$vs.notify({
            color: 'danger',
            title: 'Token inválido!',
            text: `Os tokens de autenticação da sua conta são inválidos ou estão expirados. Por favor, conecte novamente.`,
            time: 8000
          })
          return;
        }

        this.$vs.notify({
          title: 'Sentimos muito ;(',
          text: 'Revise todos os campos preenchidos, pois tivemos um erro na criação desse modelo de mensagem.',
          color: 'danger'
        })

        return;
      }

      this.$vs.notify({
        title: '😁',
        text: 'Você criou um novo modelo de mensagem com sucesso!',
        color: 'success'
      })

      await this.$router.push(formatRouteTenantPath('/meta/template-messages'))
    }
  }
}
</script>
